import { useEffect, useRef } from 'react';
import useProto from '~/client/features/Proto/hooks/useProto';
import protoChatId from '~/client/features/Proto/protoChatId';

type Event = MouseEvent | TouchEvent;

type Args = {
  handler: (event?: Event) => void;
  allowCommsClick?: boolean;
};

const useOnClickOutside = <T extends HTMLElement = HTMLElement>({
  handler,
  allowCommsClick,
}: Args) => {
  const { isProtoEnabled } = useProto();
  const elementRef = useRef<T>(null);
  useEffect(() => {
    const listener = (event: Event) => {
      const el = elementRef?.current;
      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains((event?.target as Node) || null)) {
        return;
      }
      const commsEl = document.getElementById(
        isProtoEnabled ? protoChatId : 'comms',
      );
      const walletConnectModalEl =
        document.getElementsByTagName('wcm-modal')?.[0];
      const coinbaseModalEl = document.getElementsByClassName(
        '-cbwsdk-connect-dialog',
      );
      if (walletConnectModalEl?.contains(event.target as Node)) {
        return;
      }
      if (
        coinbaseModalEl?.[coinbaseModalEl.length - 1]?.contains(
          event.target as Node,
        )
      ) {
        return;
      }
      if (
        allowCommsClick &&
        commsEl?.contains?.((event?.target as Node) || null)
      ) {
        return;
      }
      handler(event);
    };
    document.addEventListener(`mousedown`, listener);
    document.addEventListener(`touchstart`, listener);
    return () => {
      document.removeEventListener(`mousedown`, listener);
      document.removeEventListener(`touchstart`, listener);
    };
    // Reload only if ref or handler changes
  }, [allowCommsClick, handler, isProtoEnabled]);
  return { elementRef };
};

export default useOnClickOutside;
